import React from 'react';
import PropTypes from 'prop-types';
import { GoogleLogin } from 'react-google-login';
import { Box, Text } from '@houzz/ui';

import { handleLogin, logout } from '../services/auth';

const PrivateRoute = ({ handleAuthRequest }) => {
    return (
        <Box
            as="section"
            className="private-route"
            flexGrow="1"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            width="60%"
            margin="80px auto"
        >
            <Text as="h4" my="S">
                This page is restricted to Houzz employees only!
            </Text>
            <Text as="p" size="medium" my="S" mb="L">
                To view this page, you must be a Houzz employee and log in with your Houzz Account.
            </Text>
            <GoogleLogin
                clientId="81258383996-9bu0g5hdfnrdonqo3edrr47oj1n1j2ke.apps.googleusercontent.com"
                onSuccess={(...args) => {
                    handleLogin(args);
                    handleAuthRequest();
                }}
                onFailure={() => {
                    logout();
                    handleAuthRequest();
                }}
                hostedDomain="houzz.com"
                isSignedIn={true}
                cookiePolicy={'single_host_origin'}
            />
        </Box>
    );
};

PrivateRoute.propTypes = {
    handleAuthRequest: PropTypes.func,
};

export default PrivateRoute;
